import { render, staticRenderFns } from "./AuthEmailSuccess.vue?vue&type=template&id=669af2a6&scoped=true&"
import script from "./AuthEmailSuccess.vue?vue&type=script&lang=js&"
export * from "./AuthEmailSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669af2a6",
  null
  
)

export default component.exports